export const PageNotFound = () => {
return (
    <div>
        <img src="https://www.freeiconspng.com/thumbs/error-icon/error-icon-32.png" alt="Error image" />
        <h2>Page not found</h2>
    </div>
)
}